import { graphqlClient } from "./client"
import {
  ConfirmElecTradeDocument,
  ConfirmElecTradeMutationVariables,
  ConfirmGasTradeDocument,
  ConfirmGasTradeMutationVariables,
  DeleteSynchronizedAccountDocument,
  DeleteSynchronizedAccountMutationVariables,
  DeleteUserDocument,
  DeleteUserMutationVariables,
  InsertElecNominationsDocument,
  InsertElecNominationsMutationVariables,
  InsertElecTradeDocument,
  InsertElecTradeHistoryDocument,
  InsertElecTradeHistoryMutationVariables,
  InsertElecTradeMutationVariables,
  InsertGasTradeDocument,
  InsertGasTradeHistoryDocument,
  InsertGasTradeHistoryMutationVariables,
  InsertGasTradeMutationVariables,
  MarkCreditCheckAsDepositPaidDocument,
  MarkCreditCheckAsDepositPaidMutationVariables,
  ToggleReferralSettingDocument,
  ToggleReferralSettingMutationVariables,
  UnlockElecTradeDocument,
  UnlockElecTradeMutationVariables,
  UnlockGasTradeDocument,
  UnlockGasTradeMutationVariables,
  UpdateCallTraceAuditsDocument,
  UpdateCallTraceAuditsMutationVariables,
  UpdateConfigurationsDocument,
  UpdateConfigurationsMutationVariables,
  UpdateElecTradeDocument,
  UpdateElecTradeMutationVariables,
  UpdateGasTradeDocument,
  UpdateGasTradeMutationVariables,
  UpdateProductFlagsDocument,
  UpdateProductFlagsMutationVariables,
  UpdateMeterReminderDocument,
  UpdateMeterReminderMutationVariables,
  UpdateStatusAndCommentDocument,
  UpdateStatusAndCommentMutationVariables,
  UpdateUserDocument,
  UpdateUserMutationVariables,
  UpdateUserPasswordDocument,
  UpdateUserPasswordMutationVariables,
  InsertCancellationReasonMutationVariables,
  InsertCancellationReasonDocument,
  InsertEmailTemplateDocument,
  InsertEmailTemplateMutationVariables,
  InsertEmailTemplateAsLiveDocument,
  InsertEmailTemplateAsLiveMutationVariables,
  SetLiveEmailTemplateVersionDocument,
  SetLiveEmailTemplateVersionMutationVariables,
} from "./generated/graphql"

export const HasuraMutations = {
  user: {
    update: () => ({
      mutationFn: (payload: UpdateUserMutationVariables) =>
        graphqlClient.request(UpdateUserDocument, payload),
    }),
    updatePassword: () => ({
      mutationFn: (payload: UpdateUserPasswordMutationVariables) =>
        graphqlClient.request(UpdateUserPasswordDocument, payload),
    }),
    delete: () => ({
      mutationFn: (payload: DeleteUserMutationVariables) =>
        graphqlClient.request(DeleteUserDocument, payload),
    }),
  },
  account: {
    updateGdprFields: () => ({
      mutationFn: (payload: UpdateCallTraceAuditsMutationVariables) =>
        graphqlClient.request(UpdateCallTraceAuditsDocument, payload),
    }),
  },
  cancellationReason: {
    create: () => ({
      mutationFn: (payload: InsertCancellationReasonMutationVariables) =>
        graphqlClient.request(InsertCancellationReasonDocument, payload),
    }),
  },
  configurations: {
    update: () => ({
      mutationFn: (payload: UpdateConfigurationsMutationVariables) =>
        graphqlClient.request(UpdateConfigurationsDocument, payload),
    }),
  },
  product: {
    updateFeatureFlags: () => ({
      mutationFn: (payload: UpdateProductFlagsMutationVariables) =>
        graphqlClient.request(UpdateProductFlagsDocument, payload),
    }),
  },
  referral: {
    toggleCodeBlacklistStatus: () => ({
      mutationFn: (payload: ToggleReferralSettingMutationVariables) =>
        graphqlClient.request(ToggleReferralSettingDocument, payload),
    }),
  },
  comms: {
    updateMeterReminder: () => ({
      mutationFn: (payload: UpdateMeterReminderMutationVariables) =>
        graphqlClient.request(UpdateMeterReminderDocument, payload),
    }),
  },
  readings: {
    updateStatus: () => ({
      mutationFn: (payload: UpdateStatusAndCommentMutationVariables) =>
        graphqlClient.request(UpdateStatusAndCommentDocument, payload),
    }),
  },
  trades: {
    insertGasTrade: () => ({
      mutationFn: (payload: InsertGasTradeMutationVariables) =>
        graphqlClient.request(InsertGasTradeDocument, payload),
    }),
    insertElecTrade: () => ({
      mutationFn: (payload: InsertElecTradeMutationVariables) =>
        graphqlClient.request(InsertElecTradeDocument, payload),
    }),
    confirmGasTrade: () => ({
      mutationFn: (payload: ConfirmGasTradeMutationVariables) =>
        graphqlClient.request(ConfirmGasTradeDocument, payload),
    }),
    confirmElecTrade: () => ({
      mutationFn: (payload: ConfirmElecTradeMutationVariables) =>
        graphqlClient.request(ConfirmElecTradeDocument, payload),
    }),
    updateElecTrade: () => ({
      mutationFn: (payload: UpdateElecTradeMutationVariables) =>
        graphqlClient.request(UpdateElecTradeDocument, payload),
    }),
    updateGasTrade: () => ({
      mutationFn: (payload: UpdateGasTradeMutationVariables) =>
        graphqlClient.request(UpdateGasTradeDocument, payload),
    }),
    unlockElecTrade: () => ({
      mutationFn: (payload: UnlockElecTradeMutationVariables) =>
        graphqlClient.request(UnlockElecTradeDocument, payload),
    }),
    unlockGasTrade: () => ({
      mutationFn: (payload: UnlockGasTradeMutationVariables) =>
        graphqlClient.request(UnlockGasTradeDocument, payload),
    }),
    insertGasTradeHistory: () => ({
      mutationFn: (payload: InsertGasTradeHistoryMutationVariables) =>
        graphqlClient.request(InsertGasTradeHistoryDocument, payload),
    }),
    insertElecTradeHistory: () => ({
      mutationFn: (payload: InsertElecTradeHistoryMutationVariables) =>
        graphqlClient.request(InsertElecTradeHistoryDocument, payload),
    }),
    insertElecNominations: () => ({
      mutationFn: (payload: InsertElecNominationsMutationVariables) =>
        graphqlClient.request(InsertElecNominationsDocument, payload),
    }),
  },
  accountSync: {
    disableAutoSyncAccount: () => ({
      mutationFn: (payload: DeleteSynchronizedAccountMutationVariables) =>
        graphqlClient.request(DeleteSynchronizedAccountDocument, payload),
    }),
  },
  creditChecks: {
    markCreditCheckAsDepositPaid: () => ({
      mutationFn: (payload: MarkCreditCheckAsDepositPaidMutationVariables) =>
        graphqlClient.request(MarkCreditCheckAsDepositPaidDocument, payload),
    }),
  },
  emailTemplates: {
    insert: () => ({
      mutationFn: (payload: InsertEmailTemplateMutationVariables) =>
        graphqlClient.request(InsertEmailTemplateDocument, payload),
    }),
    insertAsLive: () => ({
      mutationFn: (payload: InsertEmailTemplateAsLiveMutationVariables) =>
        graphqlClient.request(InsertEmailTemplateAsLiveDocument, payload),
    }),
    setLiveVersion: () => ({
      mutationFn: (payload: SetLiveEmailTemplateVersionMutationVariables) =>
        graphqlClient.request(SetLiveEmailTemplateVersionDocument, payload),
    }),
  },
}
